import styled, { keyframes } from 'styled-components'
import { KeyboardArrowLeft } from '@styled-icons/material-rounded'

import { slideInRight } from 'react-animations'


const slideInRightAnimation = keyframes`${slideInRight}`

export const SubmenuBurger = styled.ul`
  position: absolute;
  width: 380px;
  height: 768px;
  top: 0;
  left: 0;
  padding: 0 0;
  z-index: 100;
  background-color: ${props => props.theme.colors.white};
  list-style: none;
  box-sizing: border-box;
  animation: 0.5s ${slideInRightAnimation};

`

export const BackMenu = styled.p`
  font-family: ${props => props.theme.font};
  font-size: 16px;
  line-height: 24px;
  padding-left: 18px;
  font-weight: 500px;
`

export const SubmenuTitleContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 50px;
  position: relative;
  padding-top: 20px;
  padding-left: 2.4rem;

`

export const SubmenuTitle = styled.p`
  margin: 0;
  font-size: 24px;
  color: ${props => props.theme.menu.submenuTitle};
  font-family: ${props => props.theme.font};
  border-bottom: 1px ${props => props.theme.menu.border} solid;
  padding-left: 2.4rem;
`

export const SubmenuItem = styled.li`
  color: ${props => props.theme.menu.list};
  &:hover {
    background-color: rgba(22, 22, 22, 0.04);
  }
`

export const SubmenuLink = styled.a`
  display: block;
  text-decoration: none;
  padding-left: 2.4rem;
  padding-top: 20px;
  padding-bottom: 20px;
  color: ${props => props.theme.menu.text};
  font-size: 16px;
  line-height: 24px
  -webkit-font-smoothing: antialiased;
`

// ICONS
export const ArrowLeftIcon = styled(KeyboardArrowLeft)`
  color: ${props => props.theme.menu.text};
  position: absolute;
  left: -10px;
  padding-left: 2.4rem;
`
